import { useMemo } from "react";
import "./styles.scss";
import AddIcon from "assets/icons/AddIcon";
import AddFileIcon from "assets/icons/AddFileIcon";
import FileIcon from "assets/icons/FileIcon";

export interface NewInvoiceOptionProps {
  label: string
  description: string
  type: "new" | "xml" | "zip"
}

const NewInvoiceOption = (props: NewInvoiceOptionProps) => {
  const { label, description, type } = props;

  const handleShowIcon = useMemo(() => {
    switch(type){
      case "new":
        return <AddIcon />
      case "xml":
        return <AddFileIcon />
      case "zip":
        return <FileIcon />
      default:
        return <div></div>
    }
  }, [type])

  return (
    <div className="new-invoice-option">
      <div className="invoice-option-icon">
        {handleShowIcon}
      </div>
      <div className="invoice-option-labels">
        <span className="option-label-title">{label}</span>
        <span className="option-label-description">{description}</span>
      </div>
    </div>
  )
}

export default NewInvoiceOption;